export enum LiabilityStatus {
  ChargePending = 'charge_pending',
  NoCollectionAttempt = 'no_collection',
  Paid = 'paid',
  PaidOffline = 'paid_offline',
  PatientHold = 'patient_hold',
  ReadOnlyPaid = 'read_only_paid',
  ReadOnlyUnpaid = 'read_only_unpaid',
  Refunded = 'refunded',
  RequestSent = 'request_sent',
  Voided = 'voided',
  WrittenOff = 'written_off',
}

export enum PaymentChargeStatus {
  Completed = 'completed',
  CompletedCash = 'completed_cash',
  DoNotComplete = 'do_not_complete',
  Failed = 'failed',
  Pending = 'pending',
  Refunded = 'refunded',
}

export enum PaymentRequestStatus {
  AttemptingCollection = 'attempting_collection',
  Collected = 'collected',
  NotCollecting = 'not_collecting',
}
